import { PayPalOrderStoredType } from "types";

export const getPayPalOrders = (state) =>
  state.paypal.orders as PayPalOrderStoredType[];
